import { render, staticRenderFns } from "./RentalStatus.vue?vue&type=template&id=37a02cfa&scoped=true&"
import script from "./RentalStatus.vue?vue&type=script&lang=js&"
export * from "./RentalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a02cfa",
  null
  
)

export default component.exports